import React from 'react';
import { Edit, TextInput, BooleanInput, DisabledInput, FormTab, number } from 'react-admin';

import { TabbedForm } from '../customViews';
import RevenueCenterTitle from './RevenueCenterTitle';

const RevenueCenterEdit = (props) => (
	<Edit title={<RevenueCenterTitle />} {...props}>
		<TabbedForm>
			<FormTab label="Details">
				<TextInput source="index" validate={number()} />
				<TextInput source="name" />
				<BooleanInput source="isDefault" />
				<BooleanInput source="isDelivery" />
				<BooleanInput source="isTable" />
				<BooleanInput source="isSelfService" />
				<BooleanInput source="active" />
				<DisabledInput source="createdAt" />
				<DisabledInput source="updatedAt" />
				<DisabledInput source="createdBy" />
				<DisabledInput source="updatedBy" />
			</FormTab>
		</TabbedForm>
	</Edit>
);

export default RevenueCenterEdit;
